module.exports = __webpack_public_path__ + "img/so.1c67d9c9.svg";